import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'
import type { CronAnswer } from './cronAnswer'

/**
 * Settings → Easeedesk → Auto comments.
 *
 * Perechile vechi: `settings/easeedesk/auto_comments_settings`,
 * `get_auto_comments_list`, `get_auto_comment_details`, `create_auto_comment`,
 * `edit_auto_comment`, `change_auto_comment_status`,
 * `remove_auto_comment_setting`, `rebuild_auto_comment_configuration`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface AutoComment {
  ID: number
  comment: string
  ticket_inactivity_time: number
  ticket_types: number[]
  active: number
}

export interface AutoCommentsList {
  auto_comments: AutoComment[]
}

export interface AutoCommentsShell {
  title: string
  moduleUrl: string
  ticket_types: { ID: number; type_name: string }[]
}

export function autoCommentsShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'auto_comments'],
    queryFn: () => apiGet<AutoCommentsShell>('/settings/easeedesk/auto_comments'),
  })
}

export function autoCommentsListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'auto_comments', 'list'],
    queryFn: () => apiGet<AutoCommentsList>('/settings/easeedesk/auto_comments/list'),
  })
}

export function createAutoComment(comment: string, ticket_inactivity_time: number, ticket_types: number[]) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/auto_comments', {
    comment,
    ticket_inactivity_time,
    ticket_types,
  })
}

export function updateAutoComment(
  id: number,
  comment: string,
  ticket_inactivity_time: number,
  ticket_types: number[],
) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/auto_comments/${id}`, {
    comment,
    ticket_inactivity_time,
    ticket_types,
  })
}

export function changeAutoCommentStatus(id: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/auto_comments/${id}/status`, { active: on ? 'on' : 'off' })
}

export function removeAutoComment(id: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/auto_comments/${id}/remove`, {})
}

export function refreshAutoCommentsCron() {
  return apiPost<CronAnswer>('/settings/easeedesk/auto_comments/cron', {})
}
